:host {
  appearance: none;
  -webkit-appearance: none !important;
  display: block;
  background: var(--background);
  border-radius: var(--border-radius);
  height: auto;

  --border: 1px solid var(--gray-1);
  --background: var(--white);
  --background-active: var(--theme-0);
  --flipped-background: var(--white);
  --flipped-min-height: var(--flipped-min-height, 20rem);
  --flipped-transition: none;
  --border-radius: 0.5rem;
  --padding: 3rem;
  --min-height: 10rem;
  --card-width: auto;
}

:host([class*="bg-"]),
:host([class*="bg-"]) .wrap,
:host([class*="dark:bg-"]),
:host([class*="dark:bg-"]) .wrap {
  background: inherit;
}

:host([class*="overflow-hidden"]),
:host([class*="overflow-hidden"]) .wrap {
  overflow: hidden;
}

:host([class*="bg-"]),
:host([class*="bg-"]) .wrap,
:host([class*="dark:bg-"]),
:host([class*="dark:bg-"]) .wrap {
  border-color: inherit;
}

:host([tag="button"]),
:host([tag="button"]) *,
:host([tag="button"]) ::slotted(*),
:host([tag="modal"]),
:host([tag="modal"]) *,
:host([tag="modal"]) ::slotted(*) {
  cursor: pointer !important;
}

:host([padding="none"]) {
  --padding: 0rem;
}

:host([padding="tiny"]) {
  --padding: 0.5rem;
}

:host([padding="small"]) {
  --padding: 1rem;
}

:host([padding="medium"]) {
  --padding: 2rem;
}

:host([padding="large"]) {
  --padding: 4rem;
}

:host([compact]) {
  --min-height: 0rem;
}

:host([block]) {
  --card-width: 100% !important;
}

:host(.overflow-hidden) {
  overflow: hidden;
}

:host .wrap {
  appearance: none;
  -webkit-appearance: none !important;
  border: var(--border);
  width: var(--card-width);
  height: 100%;
  text-decoration: none;
  outline: none;
  display: grid;
  padding: 0;
  grid-template-columns: var(--padding) 1fr var(--padding);
  grid-template-rows: auto var(--padding) 1fr var(--padding) auto;
  grid-template-areas:
    "header header header"
    ". . ."
    ". section ."
    ". . ."
    "footer footer footer";
  border-radius: var(--border-radius);
  min-height: var(--min-height);
  background: var(--background);
  text-align: inherit;
  font-size: inherit;
  color: inherit;
}

:host([flippable]) .wrap .front,
:host([flippable]) .wrap .back {
  height: auto;
  display: grid;
  padding: 0;
  grid-template-columns: var(--padding) 1fr var(--padding);
  grid-template-rows: auto var(--padding) 1fr var(--padding) auto;
  grid-template-areas:
    "header header header"
    ". . ."
    ". section ."
    ". . ."
    "footer footer footer";
  min-height: var(--min-height);
}

:host([horizontal]) .wrap {
  grid-auto-flow: row;
}

:host([horizontal]) .wrap ::slotted(header) {
  border-radius: var(--border-radius) 0 0 var(--border-radius)
}

:host([horizontal][small]) .wrap ::slotted(header) {
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}

:host([horizontal]) .wrap,
:host([horizontal][flippable]) .wrap .front,
:host([horizontal][flippable]) .wrap .back {
  grid-template-columns: var(--header-width, auto) var(--padding) 1fr var(--padding);
  grid-template-rows: auto var(--padding) 1fr var(--padding) auto;
  grid-template-areas:
    "header . . ."
    "header . . ."
    "header . section ."
    "header . . ."
    "footer footer footer footer";
}

:host([horizontal]) .wrap ::slotted(header) {
  width: 100%;
}

:host([horizontal]) .wrap ::slotted(section) {
  margin: auto;
}

:host([horizontal][small]) .wrap,
:host([horizontal][flippable][small]) .wrap .front,
:host([horizontal][flippable][small]) .wrap .back {
  grid-template-columns: var(--padding) 1fr var(--padding);
  grid-template-rows: auto var(--padding) 1fr var(--padding) auto;
  grid-template-areas:
    "header header header"
    ". . ."
    ". section ."
    ". . ."
    "footer footer footer";
}

:host .wrap ::slotted(*),
:host .wrap ::slotted(section) {
  grid-area: section;
  max-width: calc(var(--card-width) - (var(--padding) * 2));
}

:host .wrap ::slotted(*.flush),
:host .wrap ::slotted(section.flush) {
  grid-column: 1 / span 3;
  width: 100% !important;
  max-width: 100% !important;
  grid-row: 2 / span 3;
  padding: 1rem;
}

:host .wrap ::slotted(header) {
  padding: 1rem var(--padding);
  border-bottom: var(--border) !important;
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  grid-area: header !important;
  width: calc(var(--card-width) - 2px);
  max-width: calc(var(--card-width) - 2px);
}

:host .wrap ::slotted(header.flush) {
  border-bottom: 0 !important;
  padding-bottom: 0;
}

:host .wrap ::slotted(header.subhead) {
  background: var(--theme-2);
}

:host .wrap ::slotted(header.sticky) {
  position: sticky;
  top: 0;
  z-index: 999999;
}

:host .wrap ::slotted(header.flex) {
  align-items: center;
  justify-content: space-between;
}

:host([small]) .wrap ::slotted(header.flex.sm\:wrap) {
  flex-wrap: wrap;
  flex-direction: column;
}

:host .wrap ::slotted(footer) {
  grid-area: footer !important;
  padding: 1rem var(--padding);
  border-top: var(--border) !important;
  width: calc(var(--card-width) - 2px);
  max-width: calc(var(--card-width) - 2px);
}

:host .wrap ::slotted(footer.flex) {
  align-items: center;
  justify-content: space-between;
}

:host([small]) .wrap ::slotted(footer.flex.sm\:wrap) {
  flex-wrap: wrap;
  flex-direction: column;
}

:host([has*="header"][has*="footer"]) {
  grid-template-columns: 1rem auto 1rem;
  grid-template-rows: 1fr auto 1fr;
}

:host stencil-route-link.wrap a {
  text-decoration: none;
}

:host button.wrap:active,
:host a.wrap:active,
:host stencil-route-link.wrap:active {
  background: var(--background-active);
}

:host([shadow="light"]) {
  box-shadow: 0 0.8rem 3rem -2rem var(--gray-1);
}

:host([shadow="heavy"]) {
  box-shadow: 0 0.8rem 3rem -1rem var(--gray-1);
}

:host([rounded="true"]) {
  border-radius: 1rem;
}

:host([flippable]) {
  perspective: 3000px;
  background: transparent;
}

:host([flippable]) .wrap {
  display: block;
  /* transform-style: preserve-3d; */
  background: var(--background);
}

@media screen and (prefers-reduced-motion: reduce) {
  :host([flippable][flip-ready]) .wrap {
    transition: none;
  }
}

:host([flippable][flip-ready]) .wrap {
  transition: all 0.5s var(--ease, ease-in-out) 0s, background-color 0s ease 0s;
}

:host([flippable]) .wrap .front {
  backface-visibility: hidden;
  z-index: 1;
  opacity: 1;
  height: 100%;
}

@media screen and (prefers-reduced-motion: reduce) {
  :host([flippable][flip-ready]) .wrap .front {
    transition: none !important;
  }
}

:host([flippable][flip-ready]) .wrap .front {
  transition: min-height 0.35s linear 0s, opacity 0.15s linear 0.3s !important;
}

:host([flippable]) .wrap .back * {
  backface-visibility: hidden;
}

:host([flippable]) .wrap .back {
  top: 0;
  left: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
  transform: rotateY(180deg);
  overflow-y: none;
  pointer-events: none;
  opacity: 0;
}

@media screen and (prefers-reduced-motion: reduce) {
  :host([flippable][flip-ready]) .wrap .back {
    transition: none !important;
  }
}

:host([flippable][flip-ready]) .wrap .back {
  transition: min-height 0.35s linear 0s, opacity 0.15s linear 0s !important;
}

@media screen and (prefers-reduced-motion: reduce) {
  :host([flippable][flipped][flip-ready]) .wrap .front {
    transition: none !important;
  }
}

:host([flippable][flipped][flip-ready]) .wrap .front {
  transition: min-height 0.35s linear 0s, opacity 0.15s linear 0s !important;
}

@media screen and (prefers-reduced-motion: reduce) {
  :host([flippable][flipped][flip-ready]) .wrap .back {
    transition: none !important;
  }
}

:host([flippable][flipped][flip-ready]) .wrap .back {
  transition: min-height 0.35s linear 0s, opacity 0.15s linear 0.3s !important;
}

:host([flippable]) .wrap .flip-button {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  z-index: 1;
  transform: translateZ(1px);
}

:host([flippable][flipped]) {
  --background: var(--flipped-background, white) !important;
  --min-height: var(--flipped-min-height) !important;
  z-index: 1;
}

:host([flippable][flipped]) .wrap {
  transform: rotateY(180deg);
}

:host([flippable][flipped]) .wrap .flip-button {
  transform: translateZ(-1px);
}

:host([flippable]) .wrap .back ::slotted(section) {
  height: calc(100% + var(--padding));
}

:host([flippable][flipped]) .wrap .front,
:host([flippable][flipped]) .wrap .back {
  min-height: var(--min-height);
}

:host([flippable][flipped]) .wrap .front {
  pointer-events: none;
  opacity: 0;
}

:host([flippable][flipped]) .wrap .back {
  pointer-events: initial;
  overflow-y: initial;
  opacity: 1;
}

:host([dark]) {
  --border: 1px solid var(--gray-10);
  --background: var(--gray-11);
  --background-active: var(--gray-10);
  --flipped-background: var(--gray-11);
}
